import { createContext, useContext } from 'react';

import { CustomElement } from './types';

export type RichImageResolver = (element: CustomElement) => string;

const defaultResolver: RichImageResolver = (element) => element.children?.[0]?.text || '';

const RichImageContext = createContext<RichImageResolver>(defaultResolver);

export const RichImageProvider = RichImageContext.Provider;

export const useRichImageSrc = (): RichImageResolver => useContext(RichImageContext);
